import React from 'react';
import { Shield, Download, Lock, AlertTriangle, ShieldCheck } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="comprar" className="py-24 md:py-32 bg-navy relative overflow-hidden" data-id="element-330">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-full h-full overflow-hidden opacity-20 pointer-events-none" data-id="element-331">
        <div className="absolute -top-[50%] -right-[20%] w-[80%] h-[150%] rounded-full bg-teal blur-3xl" data-id="element-332"></div>
        <div className="absolute -bottom-[50%] -left-[20%] w-[80%] h-[150%] rounded-full bg-amber blur-3xl" data-id="element-333"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-4xl relative z-10" data-id="element-334">
        {/* Urgency Block */}
        <FadeIn data-id="element-335">
          <div className="bg-amber/10 border border-amber/30 rounded-2xl p-6 mb-12 flex items-start gap-4 backdrop-blur-sm" data-id="element-336">
            <AlertTriangle className="text-amber flex-shrink-0 mt-1" size={28} data-id="element-337" />
            <div data-id="element-338">
              <h4 className="text-amber font-bold text-lg mb-1" data-id="element-339">
                Este precio con los 3 bonus es exclusivo de esta página.
              </h4>
              <p className="text-amber/80" data-id="element-340">
                No estará disponible si cerrás y volvés mañana. No estará
                disponible si lo mandás a un amigo. Solo está aquí, solo hoy,
                solo para quien tome acción ahora.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Guarantee Block */}
        <FadeIn delay={0.1} data-id="element-341">
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 mb-12 backdrop-blur-sm text-center" data-id="element-342">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-teal/20 text-teal-light mb-6" data-id="element-343">
              <ShieldCheck size={32} data-id="element-344" />
            </div>
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-4" data-id="element-345">
              Garantía total de 30 días
            </h3>
            <p className="text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-346">
              Si en 30 días aplicás el método y sentís que no te ayudó en nada,
              te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios
              complicados.
            </p>
            <p className="text-xl font-bold text-white mt-6" data-id="element-347">
              No tenés nada que perder. Tu hijo sí.
            </p>
          </div>
        </FadeIn>

        {/* CTA Block */}
        <FadeIn delay={0.2} data-id="element-348">
          <div id="proteger-ahora" className="text-center" data-id="element-349">
            <a href="https://www.auriadigitalstore.com/cart/52166608257317:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-flex flex-col items-center justify-center w-full md:w-auto px-8 md:px-12 py-6 bg-amber hover:bg-amber-light text-navy font-bold rounded-2xl transition-all duration-300 transform hover:-translate-y-1 shadow-[0_10px_40px_-10px_rgba(212,168,67,0.6)]" data-id="element-350">
              <span className="text-2xl md:text-3xl mb-2 flex items-center gap-3" data-id="element-351">
                <Shield size={28} data-id="element-352" />
                SÍ QUIERO PROTEGER A MI HIJO AHORA
              </span>
              <span className="text-navy/80 text-lg font-medium" data-id="element-353">
                Acceder al paquete completo por $7.39
              </span>
              <span className="text-navy/60 text-sm mt-1" data-id="element-354">
                (Ebook + 3 Bonus gratis — Descarga inmediata)
              </span>
            </a>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-gray-400 text-sm" data-id="element-355">
              <div className="flex items-center gap-2" data-id="element-356">
                <Lock size={16} data-id="element-357" /> Pago seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-358">
                <Download size={16} data-id="element-359" /> Descarga inmediata
              </div>
              <div className="flex items-center gap-2" data-id="element-360">
                <ShieldCheck size={16} data-id="element-361" /> Garantía 30 días
              </div>
              <div className="flex items-center gap-2" data-id="element-362">
                <Lock size={16} data-id="element-363" /> Sin suscripciones
              </div>
            </div>

            <div className="mt-16 max-w-2xl mx-auto" data-id="element-364">
              <p className="text-xl text-gray-300 leading-relaxed mb-6 font-serif italic" data-id="element-365">
                Esta noche, antes de dormir, tu hijo va a volver a pensar en
                mañana. La diferencia es que esta vez, vos ya tenés el plan.
              </p>
              <p className="text-2xl font-bold text-white mb-12" data-id="element-366">
                No lo hagás esperar más.
              </p>

              <div className="inline-block border-t border-white/10 pt-8" data-id="element-367">
                <p className="text-gray-400 text-sm uppercase tracking-widest font-bold" data-id="element-368">
                  "Miles de padres ya tienen este método. El único paso que
                  falta es el tuyo."
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}